<template>
    <div>
        <CoeFilter
            style="margin-bottom: 20px"
            @status-changed="handleOnStatusChanged"
            :selected-dates="selectedDates"
            @date-change="handleDateChanged"
        />
        <CoeList
            :requests-data-list="coeList"
            :is-loading="isLoading"
            :total-count="totalCount"
            :current-page="currentPage"
            :total-per-page="limit"
            :limit="limit"
            @view="openCoeModalForEmployee"
            @reload="handleReload"
            @on-page-change="handleOnPageChanged"
        />
        <CreateCoeModal ref="CreateRequest" @create="handleReload" />
    </div>
</template>
<script>
import CreateCoeModal from '@/components/Requests/Dev/COE/CreateCoeModal.vue';
import CoeFilter from '@/components/Requests/Dev/COE/CoEFilter.vue';
import CoeList from '@/components/Requests/Dev/COE/CoeList.vue';
import { getPaginatedCoe } from '@/services/coe.services';
import { endOfDate, startOfDate } from '../../../../../utility/helper';

export default {
    components: { CoeFilter, CoeList, CreateCoeModal },
    data() {
        return {
            coeList: [],
            filters: {},
            currentPage: 1,
            totalCount: 1,
            limit: 10,
        };
    },
    async mounted() {
        await this.fetchData();
    },
    methods: {
        openCoeModal() {
            this.$refs.CreateRequest.openModal();
        },
        openCoeModalForEmployee(e) {
            this.$refs.CreateRequest.openModalForEmployee(e);
        },
        handleOnPageChanged(page) {
            this.currentPage = page;
            this.fetchData();
        },
        async fetchData() {
            const { data } = await getPaginatedCoe({ filter: this.filters, page: this.currentPage, limit: this.limit });
            this.coeList = data.data;
            this.totalCount = data.totalCount;
        },
        async handleReload() {
            await this.fetchData();
        },
        handleOnStatusChanged(status) {
            delete this.filters['status'];
            this.filters = { ...this.filters, ...(status && { status }) };
            this.fetchData();
        },
        handleDateChanged(date) {
            delete this.filters['createdAt'];
            this.filters = {
                ...this.filters,
                ...(date.from && { createdAt: { $gte: startOfDate(date.from), $lte: endOfDate(date.to) } }),
            };
            this.fetchData();
        },
    },
};
</script>
